import { Edit, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { StaffFormFields } from './StaffForm';
import { RemoveFromOrganizationButton } from './RemoveFromOrganizationButton';

export const StaffEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm toolbar={<MyToolbar resource="staff" />}>
      <MyFormContainer>
        <StaffFormFields isCreate={false} />
        <RemoveFromOrganizationButton />
      </MyFormContainer>
    </SimpleForm>
  </Edit>
);

export default StaffEdit;
